export default function generateCSSSelector(className) {
  var pseudo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var specificityPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var propertyPriority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var classNameSelector = ".".concat(className).repeat(propertyPriority);
  return "".concat(specificityPrefix).concat(classNameSelector).concat(pseudo);
}